/**
 * Typeguard that verifies that the given node is piece of text.
 */
export function isText(node: Node): node is Text {
    return node.nodeType === node.TEXT_NODE;
}
